import { ThemeComponent } from "@/theme/ThemeComponent";
import { Component } from "@eastsideco/salvo-ts";

@Component
export class VoyadoCollectionSorting extends ThemeComponent {

}
